import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/sitemap/page.tsx");
